import { withOverrideLegacy } from '~/App/hocs/with-override-legacy';

import { ArticlePost } from './ArticlePost';
import { loadData } from './ArticlePost.LoadData';

export default withOverrideLegacy(ArticlePost, loadData);
